export default "__VITE_ASSET__e50a49d9__"